import React from "react";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import "./style.scss";
import { useTranslation } from "react-i18next";

const CardDescription: React.FC = () => {
  const userData = useSelector((state: State) => state.auth.userData.promotion);
  const { t } = useTranslation();
  return (
    <React.Fragment>
      {userData && (
        <React.Fragment>
          {userData.displayName ? <span>{userData.displayName}</span> : <span>{t("brak")}</span>}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default CardDescription;
